import { styled } from 'parkdepot-shared/theme'

export const WarningTextContainer = styled('div', ({ $theme }) => ({
    backgroundColor: '#F7F7FF',
    padding: '16px 24px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    margin: '16px 0',
    borderRadius: '16px',

    [$theme.mediaQuery.large]: {
        margin: '32px 0'
    }
}))

export const WarningIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.primary,
    fontSize: '12px',
    fontWeight: 600
}))

export const WarningText = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0,
    fontSize: '12px',
    lineHeight: '18px',
    color: $theme.colors.primary,
    fontWeight: 700
}))

export const ErrorContainer = styled('div', ({ $theme }) => ({
    backgroundColor: '#FEF3F2',
    border: '3px solid #F04438',
    padding: $theme.sizing.scale400
}))

export const DropinWrapper = styled('div', ({ $theme }) => ({
    fontSize: '10px',
    lineHeight: '14px',
    marginTop: '4px',
    marginBottom: '18px'
}))

export const LoadingContainer = styled('div', () => ({
    width: '100%',
    height: '250px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#eee',
    borderRadius: '24px'
}))
